(function () {
    'use strict';

    // Get configuration from window object (set in theme.liquid)
    const config = window.GeoLockConfig || {
        allowedCountries: ['US'], // Fallback default
        apiEndpoint: 'https://ipapi.co/json/',
        fallbackBehavior: 'lock',
        customCssUrl: '',
        customJsUrl: ''
    };

    // Detect location and conditionally load custom files
    async function checkGeoLock() {
        try {
            const response = await fetch(config.apiEndpoint);
            let userCountry = '';

            // Handle Cloudflare /cdn-cgi/trace (Text format)
            if (config.apiEndpoint.includes('/cdn-cgi/trace')) {
                const text = await response.text();
                const lines = text.split('\n');
                const locLine = lines.find(line => line.startsWith('loc='));
                if (locLine) {
                    userCountry = locLine.split('=')[1].trim();
                }
            } else {
                // Handle JSON fallback (like ipapi.co)
                const data = await response.json();
                userCountry = data.country_code || data.country;
            }

            if (!userCountry) {
                throw new Error('Could not determine country from response');
            }

            if (!config.allowedCountries.includes(userCountry)) {
                console.log(`[GeoLock] Site Locked (Country: ${userCountry})`);
                loadCustomFiles();
            } else {
                console.log(`[GeoLock] Site Unlocked (Country: ${userCountry})`);
            }
        } catch (error) {
            console.warn('[GeoLock] Detection failed:', error);
            // Fallback: lock prices if detection fails
            if (config.fallbackBehavior === 'lock') {
                console.log('[GeoLock] Fallback: Site Locked (Detection Failed)');
                loadCustomFiles();
            }
        }
    }

    function loadCustomFiles() {
        // Inject custom.css
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = config.customCssUrl;
        document.head.appendChild(link);

        // Inject custom.js
        const script = document.createElement('script');
        script.src = config.customJsUrl;
        script.defer = true;
        document.body.appendChild(script);
    }

    // Run on page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', checkGeoLock);
    } else {
        checkGeoLock();
    }
})();
